import { render, staticRenderFns } from "./activityRank.vue?vue&type=template&id=47230357&scoped=true&"
import script from "./activityRank.vue?vue&type=script&lang=ts&"
export * from "./activityRank.vue?vue&type=script&lang=ts&"
import style0 from "./activityRank.vue?vue&type=style&index=0&id=47230357&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47230357",
  null
  
)

export default component.exports